import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { GlobalDataService } from '../services/global-data.service';
import { EmitterService } from '../services/emitter.service';
@Component({
  selector: 'app-logout',
  templateUrl: '../views/logout.component.html',
  styleUrls: ['../css/logout.component.css'],
  //providers: [GlobalDataService]
})
export class LogoutComponent implements OnInit {

  constructor(public _dataService: GlobalDataService, public _router: Router,private _emitterService: EmitterService,) { }

  ngOnInit() {
      this.logout()
  }

logout(){ 
      //var uuid = localStorage.getItem("uuid")        
  const uuid = sessionStorage.getItem("uuid");
  this._dataService.logout({"userUUID" :uuid}, (res) => {
          if(res.statusCode==200) {
             localStorage.clear();
             sessionStorage.clear();
             this._router.navigate(['login']); 
          } else {
           /* failed API */   
             localStorage.clear();
             sessionStorage.clear();
             this._router.navigate(['login']); 
          } 
        });
         this._dataService.redirectUrl = "";  
        localStorage.clear();
        sessionStorage.clear();
        this._emitterService.setloadHeader(false);
        this._router.navigate(['login']);  
   }     
    
}




// WEBPACK FOOTER //
// ./src/app/modules/housekeeping/components/logout.component.ts